<template>

  <div class="d-flex flex-column h-100">

    <div class="flex-grow-0 flex-shrink-0">

      <v-row>

        <v-col>
          <o-autocomplete
            label="Location"
            v-model="formState.locationID"
            :items="locationOptions"
          />
        </v-col>

        <v-col class="text-end">
          <v-btn
            v-if="formState.locationID"
            :to="{ name: 'universalInventoryLog', params: { locationID: formState.locationID} }"
            prepend-icon="$log"
            :text="$t('titles.log')"
          />
        </v-col>

      </v-row>

    </div>

    <div class="flex-grow-1 flex-shrink-0">
      <inventory-calendar
        :location="location"
      />
    </div>

  </div>

</template>

<script setup lang="ts">

import { computed, reactive } from 'vue'

// components
import InventoryCalendar from './calendar/InventoryCalendar.vue'

// models
import Location from '../../../models/Location'

interface Props {
  locationID?: null | number // optionally passed in from the route path
}

const props = withDefaults(defineProps<Props>(), {
  locationID: null,
})

const locationOptions = computed(() => {
  return Location.getOptions('universalInventory', 'read')
})

/**
 * Form state
 */

interface FormState {
  locationID: null | number
}

const formState = reactive<FormState>({
  locationID: props.locationID,
})

/**
 * Miscellaneous
 */

const location = computed<null | Location>(() => {
  return formState.locationID ? Location.find(formState.locationID) : null
})

</script>
